import moment from 'moment'

const dataVendaSeteDias = moment()
.subtract(7, 'days')
.format('YYYY-MM-DD')
const dataVendaMesAtual = moment().format('YYYY-MM-01')
const dataVendaMesPassadoInicio = moment().subtract(1, 'month').format('YYYY-MM-01')
const dataVendaMesPassadoFim = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
const dataVendaAnoAtual = moment().format('YYYY-01-01')
const dataVendaHoje = moment().format('YYYY-MM-DD')

export default [
  {
    url: '/dashboard',
    name: 'dashboard',
    tagColor: 'warning',
    icon: 'HomeIcon',
    i18n: 'Dashboard'
  },
  {
    url: '/pages/logout',
    name: 'logout',
    tagColor: 'warning',
    icon: 'UserIcon',
    i18n: 'Sair'
  },
  {
    header: 'Clientes',
    icon: 'UserIcon',
    items: [
      {
        url: `/clientes/todos`,
        name: 'clientes-todos',
        i18n: 'Cadastros',
        icon: 'UsersIcon'
      }
    ]
  },
  {
    header: 'Comissão',
    icon: 'PackageIcon',
    items: [
      {
        url: `/comissao/solicitar-saque`,
        name: 'comissao-solicitar-saque',
        i18n: 'Solicitar Saque',
        icon: 'ShoppingCartIcon'
      },
      {
        url: `/comissao/saques-solicitados`,
        name: 'comissao-saques-solicitados',
        i18n: 'Saques Solicitados',
        icon: 'ListIcon'
      },
    ]
  },
  {
    header: 'Vendas',
    icon: 'PackageIcon',
    items: [
      {
        url: `/vendas/todas?status=Pago&created_at.start=${dataVendaHoje}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-todas',
        i18n: 'Hoje',
        icon: 'CalendarIcon'
      },
      {
        url: `/vendas/ultimos-7-dias?status=Pago&created_at.start=${dataVendaSeteDias}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-ultimos-7-dias',
        i18n: 'Últimos 7 Dias',
        icon: 'CalendarIcon'
      },
      {
        url: `/vendas/mes-atual?status=Pago&created_at.start=${dataVendaMesAtual}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-mes-atual',
        i18n: 'Mês Atual',
        icon: 'CalendarIcon'
      },
      {
        url: `/vendas/mes-passado?status=Pago&created_at.start=${dataVendaMesPassadoInicio}&created_at.end=${dataVendaMesPassadoFim}`,
        name: 'vendas-mes-passado',
        i18n: 'Mês Passado',
        icon: 'CalendarIcon'
      },
      {
        url: `/vendas/ano-atual?status=Pago&created_at.start=${dataVendaAnoAtual}&created_at.end=${dataVendaHoje}`,
        name: 'vendas-ano-atual',
        i18n: 'Ano Atual',
        icon: 'CalendarIcon'
      }
    ]
  }
]
